import { useState } from 'react'
import { leases } from '@/api/endpoints'
import type { Retained } from '@/domain/lease'
import { Err } from '@/components/Err'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'
import { CHIP_DANGER, CHIP_PLAIN } from './review/chips'

// 보존 기한의 파기·되살리기. VM 상세에만 선다(보존 중 VM 은 검토 대기에 없다) — 칩 크기는 검토 대기의 것이다.
// **좁은 화면에서 감추지 않는다**: 이 조작이 서는 곳은 여기 하나라 감추면 폰을 든 최고 관리자는 어디에서도 할 수 없다.

export function RetentionActions({ retained, onChanged, className }: { retained: Retained | null; onChanged: () => void; className?: string }) {
  const [action, setAction] = useState<'purge' | 'restore' | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  if (!retained) return null
  const word = action === 'purge' ? '파기' : '되살리기'
  const run = async () => {
    if (!action) return
    setBusy(true)
    setError(null)
    try {
      await leases[action](retained.id)
      setAction(null)
      onChanged()
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }
  return <>
    <div className={cn('flex gap-1.5', className)}>
      <button className={CHIP_DANGER} disabled={busy || retained.purging}
        onClick={() => { setError(null); setAction('purge') }}>파기</button>
      <button className={CHIP_PLAIN}
        disabled={busy || retained.purging || retained.gpus > 0 || !retained.purgeAfter}
        onClick={() => { setError(null); setAction('restore') }}>되살리기</button>
    </div>
    <Dialog open={action !== null} onOpenChange={(open) => { if (!open && !busy) setAction(null) }}>
      <DialogContent aria-describedby={undefined} className="sm:max-w-sm">
        <DialogHeader><DialogTitle>{retained.name} {word}</DialogTitle></DialogHeader>
        {action === 'purge' ? <p className="text-[12px] text-muted-foreground">VM 과 디스크가 지워집니다.</p> : null}
        <Err error={error} />
        <DialogFooter>
          <Button variant="outline" disabled={busy} onClick={() => setAction(null)}>취소</Button>
          <Button disabled={busy} onClick={run}>{busy ? `${word} 중` : word}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
}
